module.exports = __webpack_public_path__ + "static/media/Send.b0373989.png";